import React from "react";

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
  variant?: "primary" | "secondary" | "success" | "warning" | "danger" | "default";
  size?: "sm" | "md";
}

const variants: Record<string, string> = {
  default: "bg-white/10 text-white/80 border-white/20",
  primary: "bg-[#6366f1]/20 text-[#818cf8] border-[#6366f1]/30",
  secondary: "bg-white/10 text-white/80 border-white/20",
  success: "bg-emerald-500/20 text-emerald-400 border-emerald-500/30",
  warning: "bg-amber-500/20 text-amber-400 border-amber-500/30",
  danger: "bg-red-500/20 text-red-400 border-red-500/30",
};

export function Badge({ children, className = "", variant = "primary", size = "sm", ...props }: BadgeProps) {
  const sizeClass = size === "sm" ? "px-2.5 py-0.5 text-xs" : "px-3 py-1 text-sm";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border font-medium ${variants[variant] || variants.primary} ${sizeClass} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
}
